/**
 * Search API - Global search across entities
 */
import apiClient from './index'

export type SearchEntityType = 'contact' | 'company' | 'deal' | 'invoice' | 'proposal' | 'project' | 'task'

export interface SearchResult {
  id: string
  type: SearchEntityType
  title: string
  subtitle?: string
  meta?: string
}

export interface SearchResults {
  contacts: SearchResult[]
  companies: SearchResult[]
  deals: SearchResult[]
  invoices: SearchResult[]
  proposals: SearchResult[]
  projects: SearchResult[]
  tasks: SearchResult[]
}

export interface SearchResponse {
  data: SearchResults
}

export type SearchCategory = 'contacts' | 'companies' | 'deals' | 'invoices' | 'proposals' | 'projects' | 'tasks'

/**
 * Search across contacts, companies, deals, invoices, proposals, projects, and tasks
 */
export async function globalSearch(
  query: string,
  options?: {
    limit?: number
    types?: SearchCategory[]
  }
): Promise<SearchResults> {
  const params = new URLSearchParams()
  params.set('q', query)

  if (options?.limit) {
    params.set('limit', options.limit.toString())
  }

  if (options?.types) {
    params.set('types', options.types.join(','))
  }

  const response = await apiClient.get<SearchResponse>(`/search?${params.toString()}`)
  return response.data.data
}
